<template>
  <b-container fluid>
    <b-alert :show="updateSucceded" variant="success" dismissible>User was updated</b-alert>
    <b-row class="mt-4">
      <b-col cols="4">
        <b-card title="Users">
          <b-button @click="getUserDetails(0)">Create User</b-button>
          <b-form-input v-model="filtertext" placeholder="Filter"></b-form-input>
          <b-table :if="userList"
                striped
                hover
                small
                 :items="userList"
                 :fields="fields"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc"
                 @row-clicked="onRowClicked"
                 :filter="filtertext"
                 class="rankingTable">
        </b-table>
        </b-card>
      </b-col>
      <b-col cols="4">
        <UserDetailsComponent v-if="userDetails" :details="userDetails" v-on:update-details="updateDetails($event)" v-on:update-details-invite="updateDetailsInvite($event)"></UserDetailsComponent>
      </b-col>

      <b-col cols="4">
        <RolesListComponent v-if="userDetails" :details="userDetails" v-on:update-details="updateDetails($event)"></RolesListComponent>

        <template v-if="userDetails">
          <UserVariableComponent v-for="(userVar, idx) in userDetails.userVariables" v-model="userDetails.userVariables[idx]" :key="idx"></UserVariableComponent>
        </template>
      </b-col>

    </b-row>

  </b-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import UserService from "../../services/UserService";
import UserDetailsComponent from "./UserDetailsComponent";
import RolesListComponent from "./RolesListComponent";
import UserVariableComponent from "./UserVariableComponent";

export default {
    name: 'UserListPage',

    data() {
      return {
        filtertext: "",
        sortBy: 'username',
        sortDesc: false,
        userList: null,
        fields: [
          {
            key: 'username',
            sortable: true
          },
          {
            key: 'name',
            sortable: true
          },
          {
            key: 'locale',
            sortable: true
          }],
        userDetails: null,
        updateSucceded: false
      }
    },

    components: {
      RolesListComponent,
      UserDetailsComponent,
      UserVariableComponent
    },

    computed: {
      ...mapState(['activeSurvey', 'absoluteDrillPath']),
      ...mapGetters(['realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),

    },

     methods: {
       loadUsers() {
        UserService.getUserList(this.authToken, this.realmName, this.studyName).then((response) => {
          this.userList = response.data
        })
      },

     updateDetails(details) {
         UserService.updateUserDetails(this.authToken, this.realmName, details, false).then((response) => {
           this.updateSucceded = true
           this.loadUsers()
           this.getUserDetails( response.data.id )
         })
     },


       updateDetailsInvite(details) {
         UserService.updateUserDetails(this.authToken, this.realmName, details, true).then((response) => {
           this.updateSucceded = true
           this.loadUsers()
           this.getUserDetails( response.data.id )
         })
       },

       getUserDetails(userId) {
         this.updateSucceded = false

         UserService.getUserDetails(this.authToken, this.realmName, userId).then((response) => {
           this.userDetails = response.data
         })
       },

       onRowClicked(row) {
         if(row["id"]) {
           this.getUserDetails(row["id"]);
         }
       },

     },

    watch: {
      $route: {
        handler() {
          this.loadUsers()
        },
        immediate: true
      },

    }

  }
</script>